<main @fade>
  <app-breadcrumbs controller="/cabinet/dam" param="catalog_id" [breadCrumbs]="catalogBreadCrumbs"/>

  <div class="dam-header">
    <h4>Файлы</h4>

    <small *ngIf="totalElements > 0">Всего {{ totalElements }} {{ createLabel(totalElements, 'файл|файла|файлов') }}</small>

    <app-dam-search-elastic [url]="getListURI()"/>

    <app-view-changing-tabs (viewChangeEvent)="showProductBlocks($event)" [isShowList]="isShowList"/>

    <button nbButton size="small" (click)="windowService.open(NewFolderDialog)" i18n-nbTooltip="@@CreateFolder" nbTooltip="Создать папку">
      <nb-icon icon="folder-add-outline"/>
    </button>

    <button nbButton size="small" *ngIf="catalogId" [routerLink]="catalogId !== 0 ? ['create', catalogId] : ['create']" i18n-nbTooltip="@@CreateFolder" nbTooltip="Редактировать папку">
      <nb-icon icon="edit-outline"/>
    </button>

    <button nbButton size="small" (click)="windowService.open(MassOperationsDialog)">
      <nb-icon icon="layers-outline"/>
      Массовые операции
    </button>

    <button nbButton size="small" (click)="toggleFilters()">
      <nb-icon icon="options-2-outline"/>
      Фильтры
      <app-filter-count [filter]="filter"/>
    </button>

    <button nbButton size="small" [disabled]="isRootCatalog()" (click)="windowService.open(FileDownloadDialog)">
      Загрузить файл
    </button>

    <nb-select *ngIf="pagination" placeholder="Сортировка" size="small" (selectedChange)="changeSort($event)" i18n-nbTooltip="@@Sorting" nbTooltip="Сортировка" [selected]="pagination.order + '-' + pagination.direction">
      <nb-option value="header_asc">Название: A -> Z</nb-option>
      <nb-option value="header_desc">Название: Z -> A</nb-option>
      <nb-option value="createdAt_asc">Старые</nb-option>
      <nb-option value="createdAt_desc">Новые</nb-option>
      <nb-option value="updatedAt_desc">Измененные</nb-option>
    </nb-select>
  </div>

  <app-filter-panel [filter]="filter"/>

  <div class="dam">
    <ng-container *ngIf="(data | async) as list">
      <div class="dam__center" [ngClass]="{'active': productShow}">
        <app-plates-view [isShowProductList]="isShowList" [pagination]="pagination" [damElements]="list" (elementClickEventEmitter)="elementClickEventHandler($event)" (elementSelectEvent)="onElementSelect($event)" (elementShareEvent)="shareDamItems([$event])" [selected$]="selected$"/>
      </div>
      <div class="dam__right" [ngClass]="{'content': true, 'active': productShow}">
        <app-dam-element-preview id="dam-element-preview" [isOpen]="productShow" [_damElement]="damElasticDTO" [damItemVersions]="damItemVersionWithDocumentInfo" [damItemVersionWithDocumentInfoExtensions]="damItemVersionWithDocumentInfoExtensions" [fileExtensions]="damItemVersionWithDocumentInfoExtensionsCount" (closeEvent)="closeSidebar()" (elementShareEvent)="shareDamItems([$event])"/>
      </div>
    </ng-container>
  </div>

  <ng-template #FileDownloadDialog>
    <app-file-upload-dam (onFileUnloaded)="onFileUnloaded($event)"/>
  </ng-template>

  <ng-template #MassOperationsDialog let-windowRef="windowRef">
    <div class="mass-operations">
      <form [formGroup]="formBatch" (ngSubmit)="batchSubmit(windowRef)">
        <nb-card-header>
          Массовые операции
        </nb-card-header>
        <nb-card-body>
          <formly-form [form]="formBatch" [fields]="configBatch.columns" [options]="optionsBatch" [model]="modelBatch"></formly-form>
        </nb-card-body>
        <nb-card-footer>
          <button type="submit" nbButton status="primary" i18n="@@Update" [disabled]="formBatch.invalid">
            Обновить
          </button>
        </nb-card-footer>
      </form>
    </div>
  </ng-template>

  <ng-template #NewFolderDialog let-windowRef="windowRef">
    <nb-card-header>Создать новую папку</nb-card-header>

    <div class="mb-3">
      <label class="form-label">Название папки</label> <input nbInput fullWidth placeholder="Название папки" alt="" [(ngModel)]="createFolderName">
    </div>

    <nb-card-footer>
      <button nbButton status="primary" (click)="createFastFolder()">
        Создать папку
      </button>
      <button nbButton (click)="windowRef.close()">
        Отменить
      </button>
    </nb-card-footer>
  </ng-template>

  <!--<app-dialog-wrapper>--><!--  <div class="dialog-elements">--><!--    <span class="dialog-elements__tittle">--><!--     Объединить элементы--><!--    </span>-->

  <!--    <div class="dialog-elements-row">--><!--      <app-dam-unit-items [damItems]="selectedElements"></app-dam-unit-items>--><!--    </div>--><!--  </div>--><!--</app-dialog-wrapper>-->

  <div class="control-panel-container" [ngClass]="{
    'fade-out': !selected$.value?.size,
    'fade-in': selected$.value?.size,
  }">
    <div class="selected-elements-control-panel">
      <div class="control-panel-item">
        {{ selected$.value?.size || 0 }} из {{ totalElements }} <span>Выбрано</span>
      </div>
      <a class="control-panel-item" (click)="shareDamItems(selectedElements)">
        <nb-icon icon="share-outline"/>
        Поделиться </a> <a class="control-panel-item" (click)="downloadDamItems()">
      <nb-icon icon="download-outline"/>
      Скачать </a> <a class="control-panel-item" [class.filter-grey-prime]="selected$.value?.size > 1" [class.filter-disabled-base]="selected$.value?.size <= 1" (click)="unitDamItems()">
      <nb-icon icon="swap-outline"/>
      Объединить </a>

      <a class="control-panel-item" (click)="enableDamItems()">
        <nb-icon icon="checkmark-circle-2-outline"/>
        Активировать </a> <a class="control-panel-item" (click)="approveDamItems()">
      <nb-icon icon="shield-outline"/>
      Одобрить </a>

      <a class="control-panel-item filter-white" (click)="deleteDamItems()">
        <nb-icon icon="trash-outline"/>
        Удалить </a>
    </div>
  </div>

  <ng-template #filtersTpl let-windowRef="windowRef">
    <ng-container *ngIf="filter?.getFields() | async as fields">
      <form [formGroup]="formFilter" (ngSubmit)="filterSubmit()">
        <formly-form [form]="formFilter" [fields]="fields" [(model)]="filter.modelFeatures"/>
      </form>
    </ng-container>

    <nb-card-footer>
      <button nbButton status="primary" type="button" (click)="windowRef.close(); filterSubmit()" i18n="@@Filter">Фильтровать</button>
      <button nbButton (click)="windowRef.close(); resetFilters();" type="button" i18n="@@ResetFilter">Сбросить фильтры</button>
    </nb-card-footer>

  </ng-template>
</main>
